import { render, staticRenderFns } from "./AddTripViewingFee.vue?vue&type=template&id=59b39c88&"
import script from "./AddTripViewingFee.vue?vue&type=script&lang=js&"
export * from "./AddTripViewingFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports